import { render, staticRenderFns } from "./setting_page.vue?vue&type=template&id=5771dfda&scoped=true&"
import script from "./setting_page.vue?vue&type=script&lang=js&"
export * from "./setting_page.vue?vue&type=script&lang=js&"
import style0 from "./setting_page.vue?vue&type=style&index=0&id=5771dfda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5771dfda",
  null
  
)

export default component.exports